import ChangePaymentModalComponent from "./ChangePaymentModalComponent";

export default ChangePaymentModalComponent;